module.exports = __webpack_public_path__ + "img/741a625.png";